<template>
  <div class="sidebarBox  fr">
    <div :class="{ 'con-left': true, small: isSmall }">
      <div class="peopleInfo">
        <template>
          <img v-if="info" :src="imgURL + info.iconUrlSmall" alt="" />
          <img v-else src="~img/personal/default_head@2x.png" alt="" />
          <p class="name">{{ info ? info.name : "未登录" }}</p>
          <div v-if="info">
            <a href="javaScript:" v-if="isAuthor">
              共<span style="color:#48a2df">{{ totalPage }}</span
              >本作品
            </a>
            <div v-else>
              <router-link to="/" class="useroption">首页</router-link>
              <router-link
                v-if="isSet"
                to="/personal/center/set"
                class="useroption"
              >
                设置
              </router-link>
              <a href="javaScript:" class="useroption" @click="logout">退出</a>
            </div>
          </div>
          <router-link
            class="useroption"
            style="font-size: 14px;display:block;text-align:center"
            to="/phoneLogin"
            v-if="!info"
            >登录</router-link
          >
        </template>
        <template> </template>
      </div>
      <ul class="person-center">
        <li v-for="(item, index) in navlist" :key="item.name">
          <router-link
            v-if="item.url"
            :to="item.url"
            :class="{ active: oIndex == index, link: link }"
            >{{ item.name }}</router-link
          >
          <span @click="bookendhint" class="setEnd" v-else>{{
            item.name
          }}</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  props: {
    navlist: Array,
    isSmall: Boolean,
    oIndex: Number,
    link: Boolean,
    isSet: Boolean,
    isAuthor: Boolean,
    totalPage: Number,
    sAuthor: Boolean
  },
  computed: mapState({
    info: state => (state.user.img ? state.user.img : null)
  }),
  methods: {
    bookendhint() {
      this.$emit("isShowhint", true);
    },
    /* 退出 */
    logout() {
      this.$store
        .dispatch("LogOut")
        .then(res => {
          if (res.success) {
            this.$router.push({
              path: "/login",
              query: "/"
            });
          }
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="stylus" scoped>
.con-left
    width 176px
    height 100%
    background rgba(255, 255, 255, 1)
    border 1px solid rgba(239, 239, 239, 1)
    padding-top 20px
    box-sizing border-box
    position absolute
    left 0
    &.small
        width 176px
    .peopleInfo
        margin 0 8px 26px
        padding-bottom 10px
        border-bottom 2px solid #EFEFEF
        text-align cener
        img
            width 90px
            height 90px
            border-radius 50%
            display block
            margin 0 auto
        .name
            margin 18px auto 8px
            font-size 14px
            font-family PingFangSC-Regular
            font-weight 400
            color rgba(51, 51, 51, 1)
            text-align center
        div
            text-align center
            a
                height 17px
                font-size 12px
                font-family PingFangSC-Regular
                font-weight 400
                color rgba(136, 136, 136, 1)
                line-height 17px
                &:nth-child(2)
                    margin 0 8px
    .person-center
        li
            width 100%
            height 40px
            a
                display block
                text-align center
                font-size 14px
                font-family PingFangSC-Regular
                font-weight 400
                color #7992A4
                line-height 40px
                border-left 6px solid rgba(255, 255, 255, 1)
                &.link
                    &.router-link-active
                        background rgba(239, 239, 239, 1)
                        border-left 6px solid #48A2DF
                        color #48A2DF
                &.router-link-exact-active
                    background rgba(239, 239, 239, 1)
                    border-left 6px solid #48A2DF
                    color #48A2DF
                &.active
                    background rgba(239, 239, 239, 1)
                    border-left 6px solid #48A2DF
                    color #48A2DF
                &:hover
                    background rgba(239, 239, 239, 1)
                    border-left 6px solid #48A2DF
                    color #48A2DF
            span
                display block
                text-align center
                font-size 14px
                font-family PingFangSC-Regular
                font-weight 400
                color #7992A4
                line-height 40px
                border-left 6px solid rgba(255, 255, 255, 1)
                cursor pointer
</style>
